<div *ngFor="let message of messages">
    <div *ngIf="message?.text" [ngClass]="{
           'alert mb-1': true,
           'alert-success': message.type === 'success',
           'alert-danger': message.type === 'error',
           'alert-warning': message.type === 'warning'
         }" class="fade show text-center alert_message" role="alert">

        <button type="button" class="close" (click)="close(message)" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>

        {{ message.text }}

        <i *ngIf="message.showSpinner" class="fa fa-spinner fa-spin"></i>
    </div>
</div>